import { ChangeEvent, ReactNode } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from "@mui/material";

import { formInputsStyles } from "../../Configuration/styles";
import { TooltipLabel } from "../Tooltips";

export const CustomCheckBox = ({
  defaultValue,
  value,
  description = undefined,
  label,
  onChange,
  isNested = false,
  required = true,
  disabled = false,
  tooltip,
}: {
  defaultValue?: boolean;
  value?: boolean;
  description?: string;
  label: string;
  onChange: (event: ChangeEvent<HTMLInputElement>, value: boolean) => void;
  isNested?: boolean;
  required?: boolean;
  disabled?: boolean;
  tooltip?: string | ReactNode;
}) => {
  const inputsStyles = formInputsStyles();

  return (
    <FormGroup sx={{ width: "fit-content" }}>
      <FormControlLabel
        className={`${inputsStyles.classes.checkbox} ${
          isNested ? inputsStyles.classes.connectivityInputReversed : ""
        }`}
        control={
          <Checkbox
            id={label}
            aria-label={label}
            defaultChecked={defaultValue}
            onChange={onChange}
            checked={value}
            disabled={disabled}
          />
        }
        label={
          tooltip ? (
            <TooltipLabel
              label={label}
              tooltipLabel={tooltip}
              translateTooltip={false}
            />
          ) : (
            label
          )
        }
        required={required}
      />
      {description && <FormHelperText>{description}</FormHelperText>}
    </FormGroup>
  );
};
